'use client';

import { useState } from 'react';

import Image from '@src/components/atoms/safe-image';
import { usePathname, useParams } from 'next/navigation';

// Assets
import Hamburger from '@public/svg/i-hamburger.jsx';
import Century21 from '@public/png/century21-gold.png';
import Century21Logo from '@public/png/century21-logo.png';
import IX from '@public/svg/i-x';
import { IoChevronDown, IoChevronUp } from 'react-icons/io5';

// Hooks
import useRedirect from '@src/hooks/useRedirect';
import useGlobalCtx from '@src/context/global-ctx';
import Popover from '@mui/material/Popover';
import FormSellRentProperty2 from "@src/components/homepage/form-sell-rent-property-v2"

const TABS = [
  {
    label: 'Beranda',
    pathname: '/',
  },
  {
    label: 'Properti',
    pathname: '/list-listing',
    options: [
      {
        label: 'Beli',
        pathname: '/list-listing?property_type_id=1',
      },
      {
        label: 'Sewa',
        pathname: '/list-listing?property_type_id=2',
      },
    ],
  },
  {
    label: 'Franchise',
    pathname: '/franchise',
  },
  {
    label: 'Tentang',
    pathname: '/about-us',
  },
  {
    label: 'Kontak',
    pathname: '/contact',
  },
];

const NavbarMobile = ({ className }) => {
  const redirect = useRedirect();
  const currentPath = usePathname();
  const [anchorEl, setAnchorEl] = useState(null);
  const [expandedMenu, setExpandedMenu] = useState(null);
  const { companySlug } = useParams();
  const { companyDetails } = useGlobalCtx();
  const [isOpenForm, setIsOpenForm] = useState(false);

  const handleToHomepage = () => {
    redirect(`/office/${companySlug}`);
  };

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setExpandedMenu(null);
  };

  const open = Boolean(anchorEl);
  return (
    <div
      className={`section-container justify-center relative bg-[#252526] border-b-[0.5px] border-solid border-[#E6E7E8] ${className}`}
    >
      <div className="px-[24px] py-[16px] w-full flex items-center gap-4 justify-between">
        <div className="flex items-center justify-between gap-4 w-full">
          <div
            className="cursor-pointer flex flex-col"
            onClick={handleToHomepage}
          >
            <Image
              src={Century21}
              alt="CENTURY 21 Indonesia"
              width="auto"
              height="auto"
              className="cursor-pointer object-contain w-[102.797px] h-[24px]"
            />
            <p className="text-[12px] text-[#BEAF87] font-satoshi-medium">
              {companyDetails?.name ?? ''}
            </p>
          </div>

          <button onClick={handleOpenMenu}>
            <Hamburger color="#FAFAFA" />
          </button>
        </div>
      </div>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            backgroundColor: '#141415',
            borderRadius: '0 0 8px 8px',
            boxShadow: '0 0 8px 0 rgba(38, 38, 39, 0.08)',
            width: '100vw',
            maxWidth: '100vw',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            margin: 0,
          },
        }}
        slotProps={{
          backdrop: {
            style: {
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
              backdropFilter: 'blur(4px)',
            },
          },
        }}
        sx={{
          '& .MuiPopover-paper': {
            left: '0 !important',
            right: '0 !important',
            top: '0 !important',
            maxWidth: '100vw !important',
          },
        }}
      >
        <div className="flex flex-col bg-[#141415]">
          <div className="h-[48px] px-[12px] flex items-center justify-between bg-[#141415]">
            {/* <Image
              src={Century21Logo}
              alt="CENTURY 21 Indonesia"
              width={131.598}
              height={32}
              className="object-contain"
            /> */}
            <button
              className="cursor-pointer w-[24px] h-[24px]"
              onClick={handleCloseMenu}
            >
              <IX width="24px" height="24px" color="#FAFAFA" />
            </button>
          </div>
          {TABS.map((tab, index) => {
            const isActive =
              currentPath === `/office/${companySlug}${tab.pathname === '/' ? '' : tab.pathname}`;
            const isExpanded = expandedMenu === index;

            return (
              <div key={`menu-item-${index}`}>
                <div
                  className={`cursor-pointer h-[48px] px-[12px] flex items-center justify-between text-[14px] ${
                    isActive ? 'font-satoshi-bold text-[#BEAF87]' : 'font-satoshi text-[#FAFAFA]'
                  } bg-[#141415] border-b-[0.5px] border-dashed border-[#686A68] hover:bg-[#252526] ${
                    index === TABS.length - 1 && !isExpanded ? 'rounded-b-[2px]' : ''
                  }`}
                  onClick={() => {
                    if (tab.options) {
                      setExpandedMenu(isExpanded ? null : index);
                    } else {
                      redirect(`/office/${companySlug}${tab.pathname}`);
                      handleCloseMenu();
                    }
                  }}
                >
                  <span>{tab.label}</span>
                  {tab.options && (
                    <button className="cursor-pointer">
                      {isExpanded ? (
                        <IoChevronUp size={16} color="#FAFAFA" />
                      ) : (
                        <IoChevronDown size={16} color="#FAFAFA" />
                      )}
                    </button>
                  )}
                </div>

                {isExpanded && tab.options && (
                  <div className="bg-[#141415]">
                    {tab.options.map((option, optIndex) => (
                      <div
                        key={`option-${optIndex}`}
                        className={`cursor-pointer h-[48px] px-[24px] flex items-center text-[14px] font-satoshi text-[#FAFAFA] bg-[#141415] border-b-[0.5px] border-dashed border-[#686A68] hover:bg-[#252526] ${
                          optIndex === tab.options.length - 1 && index === TABS.length - 1 ? 'rounded-b-[2px]' : ''
                        }`}
                        onClick={() => {
                          redirect(`/office/${companySlug}${option.pathname}`);
                          handleCloseMenu();
                        }}
                      >
                        {option.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </Popover>

      <FormSellRentProperty2 isOpen={isOpenForm} onClose={() => setIsOpenForm(false)} />
    </div>
  );
};

export default NavbarMobile;
